import React, { useEffect, useState } from "react";
import {
  Select,
  Button,
  Tabs,
  ProgressIndicator,
  Modal,
  RadioButtons,
  RadioButton,
  TextArea,
} from "@veneer/core";
import moment from "moment";
import { Trans, useTranslation } from "react-i18next";
import {
  SuppliesReport,
  PrintingVolume,
  UnderstandCalculation,
  CPP,
} from "./DetailsTables";
import {
  RenderChart,
  RenderSuppliesCompensation,
  RenderSuppliesBonus,
  RenderPrintVolumeReport,
  RenderSpecialCondition,
  RenderEmptyCard,
  RenderCreditNoteManualAdjustments
} from "./RenderConsolidateDetails";
import ConnectAPI from "../../../services/api";
import Swal from "sweetalert2";
import { authenticationService } from "../../../services/context/AuthService";


const Details = (props) => {

  const connectApi = new ConnectAPI();
  const [datesView, setDatesView] = useState([]);
  const [dateSelected, setDateSelected] = useState(null);
  const [presses, setPresses] = useState([]);
  const [
    consolidatePrintVolumeReport,
    setConsolidatePrintVolumeReport,
  ] = useState([]);
  const [suppliesBonus, setSuppliesBonus] = useState([]);
  const [suppliesCompensation, setSuppliesCompensation] = useState([]);
  const [creditNoteAdjustment, setCreditNoteAdjustment] = useState([]);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [showChartModal, setshowChartModal] = useState(false);
  const [activeTabIndex, setactiveTabIndex] = useState(0);
  const [Configtable,setConfigtable]=useState([])
  const [activePress, setActivePress] = useState("");
  const [suppliesReport, setSuppliesReport] = useState([]);
  const [costPerPrint, setCostPerPrint] = useState([]);
  const [costPerPrintEvolution, setCostPerPrintEvolution] = useState([]);
  const [loadingInitData, setLoadingInitData] = useState(false);
  const [endUser, setEndUser] = useState();
  const { id } = props.match.params;
  const [isLoading, setIsLoading] = useState(false);
  const [reportDates, setReportDates] = useState([]);
  const { t, i18n } = useTranslation();
  
  const [
    showBonusReceivedConfirmationModal,
    setShowBonusReceivedConfirmationModal,
  ] = useState(false);
  const [showBonusIssueModal, setShowBonusIssueModal] = useState(false);
  const [showCompensationIssueModal, setShowCompensationIssueModal] = useState(
    false
  );
  const [radioButtonsState, setRadioButtonsState] = useState({});
  const [
    pendingBonusReceivedConfirmation,
    setPendingBonusReceivedConfirmation,
  ] = useState(new Array());
  const [firstTimeLoading, setFirstTimeLoading] = useState(true);
  const [logs, setLogs] = useState([]);
  
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const [monthsToConfirm, setMonthsToConfirm] = useState([]);
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  //load initial data
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, [id]);
  
  const fetchData = () => {
    if (currentUser.idRole == 11 || currentUser.idRole == 12) {
      if(currentUser.idEndUser==null){
        //authenticationService.logout();
      }else{
        if (currentUser.idEndUser!=id){
          window.location.href = '/cpp/report/' + currentUser.idEndUser;
        }else{
          setLoadingInitData(true);
          getdatainitial();
        }
      }
    }else{
      setLoadingInitData(true);
      getdatainitial();
    }
  };
  const getdatainitial = ()=>{
    connectApi
      .get(
        "api/Channels/endusers/" + id + "/statementDescription",
        "",
        initDataLoad
      )
    .catch((error) => {
      setLoadingInitData(false);
      if(error.response.status==510){
        authenticationService.logout();
      }else if(error.typeerror!=null){
        Swal.fire(
          "Error " + error.response.status,
          error.response.data,
          "error"
        );
      }
      });
  }

  const initDataLoad = (status, data) => {
    get_publish();
    setReportDates(data.reportDates);
    setEndUser(data.endUser);
    setLogs(data.logs);
    localStorage.setItem("endUser", JSON.stringify(data.endUser));
    // const { items, firstDateEnabled } = loadDatesSelect(
    //   data.logs,
    //   data.reportDates,
    //   true,
    //   data.endUser
    // );
    const { items, firstDateEnabled } = loadDatesSelectOptimized(data.reportDates, data.endUser, true);
    // initBonusConfirmationModal(data.logs, data.reportDates);
    getConsolidatedReport(items[firstDateEnabled].value, data.endUser, data.logs, data.reportDates, true);
    
  };

  function getCPPPrintingVolumeAndUnderstandTheCalculationReports(
    dateSelected,
    presses
  ) {
    const costPerPrintLoad = (status, data) => {
      setCostPerPrint((oldElement) => [...oldElement, ...data]);
      console.log(data)
    };
    
    const getCostPerPrint = async () => {
      setCostPerPrint([]);
      
      presses.map((press) => {
        /*
          Case1: press.series == 3 && press.compensationProgram == 1 -> GetCostPerPrintS3Compensation
          Case2: press != 4 && !Case1 -> GetCostPerPrint
          Case3: press.seres == 4 && (press.classification == '2000' || press.clasiffication == '3000') -> GetCostPerPrintPress2x3x
          Case4: press.seres == 4 && !(press.classification == '2000' || press.clasiffication == '3000') -> GetCostPerPrintPress1x
        */
        connectApi
          .get(
            "api/Channels/getconfigbyserial",
            {
              params:{
                payload: press.idPress.substr(0,4)
            }
            },
            (status, data) => {
              let path = "api/Channels/CostPerPrint";
              if (data.length>0){
                if (data[0].whiteVisible){
                  path += "/Press2X3X";
                }else{
                  path += "/Press1X";
                  
                }
              }else{
                if (press.series == 3 && press.compensationProgram == 1) {
                  path += "/S3Compensation";
                }
              }
              connectApi
              .get(
                path,
                {
                  params: {
                    idPress: press.idPress,
                    date: dateSelected,
                    specialConditionType: press.specialConditionType,
                  },
                },
                costPerPrintLoad
              )
              .catch((error) => {
                console.log(error);
                Swal.fire(
                  "Error " + error.response.status,
                  error.response.data,
                  "error"
                );
              });

            }
        )

        /*if (press.series == 3 && press.compensationProgram == 1) {
          path += "/S3Compensation";
        } else if (press.series == "4") {
          if (
            press.classification == "20000" ||
            press.classification == "30000"
          ) {
            path += "/Press2X3X";
          } else {
            path += "/Press1X";
          }
        }*/

        
      });
    };

    getCostPerPrint();
  }
  
  function getSuppliesReport(dateSelected, presses, endUser) {

    const suppliesReportLoad = (status, data, idPress) => {
      setSuppliesReport((oldElement) => [
        ...oldElement,
        { idPress: idPress, suppliesReport: data },
      ]);
    };

    const getSuppliesReport = () => {
      setSuppliesReport([]);
      presses.map((press) => {
        connectApi
          .get(
            "api/Channels/SuppliesReport",
            {
              params: {
                idPress: press.idPress,
                date: dateSelected,
                idCustomer: endUser.idCustomer,
              },
            },
            suppliesReportLoad,
            press.idPress
          )
          .catch((error) => {
            Swal.fire(
              "Error " + error.response.status,
              error.response.data,
              "error"
            );
          });
      });
    };
    getSuppliesReport();
  }
  
  function getConsolidatedReport(dateSelected, endUser, logs, reportDates, shouldInitBonusConfirmationModal) {
    const fetchData = () => {
      setIsLoading(true);
      connectApi
        .get(
          "api/Channels/endUsers/consolidatedStatementDescription",
          {
            params: {
              endUserId: endUser?.idEndUser,
              date: dateSelected,
            },
          },
          consolidatedStamentLoad
        )
        .catch((error) => {
          setIsLoading(false);
          if (firstTimeLoading) setFirstTimeLoading(false);
          Swal.fire(
            "Error " + error.response.status,
            error.response.data,
            "error"
          );
        });
    };

    const consolidatedStamentLoad = (status, data) => {
      setConsolidatePrintVolumeReport(data.printVolumeReport);
      setSuppliesBonus(data.suppliesBonusReport);
      setCostPerPrintEvolution(data.costPerPrintEvolution);
      setSuppliesCompensation(data.suppliesCompensation);
      setCreditNoteAdjustment(data.manualAdjustmentsChannel);
      setIsLoading(false);
      if (firstTimeLoading) setFirstTimeLoading(false);
      setPresses(data.presses);
      getCPPPrintingVolumeAndUnderstandTheCalculationReports(
        dateSelected,
        data.presses
      );
      getSuppliesReport(dateSelected, data.presses, endUser);

      //check if current tab exists after changing date
      if (data?.presses.length > 0) {
        const tabIndex = data.presses.findIndex(
          (item) => item.idPress == activeTabIndex
        );
        if (tabIndex === -1) {
          setactiveTabIndex(0);
          setActivePress(0);
        }
      }

      if (shouldInitBonusConfirmationModal) {
        initBonusConfirmationModal(logs, reportDates);
      }


    };

    fetchData();
  }


  function get_publish(){
    var date="";
    fetch('api/Channels/getpublish')
    .then(response => response.json())
    .then(data => {
      var today = new Date();
      var publi=new Date(data[0].startDate);
      var i=1;
      var mo=publi.getMonth();
      while(mo<=today.getMonth()){
        date=" "+publi.getDate()+" "+(months[mo]);
        i++;
        mo=publi.getMonth()+i;
      }
      if (publi.getDate()<=today.getDate()){
        mo=publi.getMonth()+1;
        date=" "+publi.getDate()+" "+(months[mo]);
      }
      localStorage.setItem("last_publish", JSON.stringify(date));
    }
    );  
  }


  function loadDatesSelectOptimized(datesData, endUser, fromInitData) {

    //calculate if the dates should be disabled, from the oldest to the newest
    datesData.reverse().forEach((x, idx, arr) => {
      let disabled;
      switch (currentUser.idRole) {
        case 9: case 10: //channels
          disabled = endUser.group == 2 && x.shouldConsiderCompensation && !x.compensationAccepted;
          break;
        case 11: case 12: //end users
          disabled = (endUser.group == 2 && x.shouldConsiderBonus && !x.bonusAccepted) || (endUser.group != 2 && ((x.shouldConsiderBonus && !x.bonusAccepted) || (x.shouldConsiderCompensation && !x.compensationAccepted)));
          break;
        default:
          disabled = false;
          break;
      }

      //if previous index is disabled, disable this one as well
      disabled = idx === 0 ? disabled : disabled || arr[idx - 1].disabled;

      //save current disabled value
      x.disabled = disabled;

    });
   
    //return to its initial order and map options
    const options = datesData.reverse().map(x => {
      return {
        value: moment(x.date).format("YYYY-MM-DDTHH:mm:ss"),
        label:
          moment(x.date).format("MMM") +
          " " +
          moment(x.date).format("YYYY"),
        disabled: x.disabled
      };
    });

    //find index of last enabled date
    const lastEnabledIdx = options.findIndex(x => !x.disabled);
    let firstDateEnabled = 0;
    if (lastEnabledIdx > 0) {
      firstDateEnabled = lastEnabledIdx - 1;
    } else if(lastEnabledIdx === -1) {
      firstDateEnabled = options.length - 1;
    }
    options[firstDateEnabled].disabled = false;

    if (fromInitData) setDateSelected(options[firstDateEnabled].value);
    setDatesView(options);

    return { items: options, firstDateEnabled };
  }

  function initBonusConfirmationModal(logs, reportDates) {

    if (currentUser.idRole != 11 && currentUser.idRole != 12) {
      setLoadingInitData(false);
      return;
    }

    const bonusAccepted = logs.filter((log) => {
      return (log.actionDescription == "Bonus Accepted" | log.actionDescription=='Bonus Accrual Released');
    });

    const bonusConfirmed = logs.filter((log) => {
      return (log.actionDescription == "Bonus Received Confirmation" | log.actionDescription=='Bonus Accrual Released');
    });
    let pendingConfimation = new Array();

    bonusAccepted.forEach((accepted) => {
      if (
        bonusConfirmed.filter((item) => {
          return item.month == accepted.month && item.year == accepted.year;
        }).length == 0
      ) {
        pendingConfimation.push(
          months[accepted.month - 1] + " " + accepted.year.toString()
        );
      }
    });

    pendingConfimation = pendingConfimation.filter((item) => {
      return (
        item !=
        moment(reportDates[0].date).format("MMM") +
        " " +
        moment(reportDates[0].date).format("YYYY")
      );
    });

    if (pendingConfimation.length > 0) {
      pendingConfimation.reverse();

      setPendingBonusReceivedConfirmation(pendingConfimation);
      setMonthsToConfirm([0]);
      setShowBonusReceivedConfirmationModal(true);
      let stateKey = "";

      pendingConfimation.forEach((item) => {
        stateKey = "radioButton" + item.replace(/ /g, "");
        radioButtonsState[stateKey] = null;
      });
    }

    //leave at the end
    setLoadingInitData(false);
  }

  const closeModal = () => {
    setShowAlertModal(false);
  };

  const closeChartModal = () => {
    setshowChartModal(false);
  };

  const alertModalStatus = (index) => (event) => {
    event.preventDefault();
    // setactiveTabIndex(index);
    setShowAlertModal(true);
  };

  const chartModalStatus = (index) => (event) => {
    event.preventDefault();
    setshowChartModal(true);
  };

  const selectTab = (index) => (event) => {
    if (event!=0){
      connectApi
      .get(
        "api/Channels/getconfigbyserial",
        {
          params:{
            payload: event.substr(0,4)
        }
        },
        (status, data) => {
          if (data.length>0){
            setConfigtable(data[0])
          
          }
          setactiveTabIndex(event);
          setActivePress(event);    

        }
      )
    }else{
        setactiveTabIndex(event);
        setActivePress(event); 
    }
    

    
  };

  const handleStatementReport = (index) => {
    const { history } = props;
    history.push({
      pathname:
        "/cpp/report/statement/detail/" +
        endUser.idEndUser +
        "/" +
        endUser.idCustomer,
    });
  };

  

  const RenderDateList = () => {
    
    const handleChange = (name) => (event) => {
      const currentDate = event.value;

      setDateSelected(currentDate);
      if (!firstTimeLoading) getConsolidatedReport(currentDate, endUser, null, null, false);
        
    };
    return (
      <div
        style={{
          width: "200px",
          marginBottom: "16px",
        }}
      >
        <Select
          name="dates"
          onChange={handleChange()}
          //onClear={this.handleDefaultClear}
          options={datesView}
          placeholder="Dates"
          value={[dateSelected]}
          clearIcon={false}
        />
      </div>
    );
  };

  const RenderTabs = () => {

    function renderStatementButton() {
      let result = false;

      reportDates.forEach((item) => {
        if (item.shouldConsiderCompensation) result = true;
      });

      return result;
    }

    const series4 = presses.filter((p) => p.series >= 4);
    const series3CompensationOrS4 = presses.filter(
      (p) => p.compensationProgram == 1
    );
    const specialCondition = consolidatePrintVolumeReport.find(
      (item) => item.endDate != null
    );
    const mainTab = {
      //id: 'main',
      id: 0,
      label: t("consolidated"),
      //onClick:{selectTab({ tab: 0, press: '' })}
      content: firstTimeLoading ? (
        <ProgressIndicator appearance="linear" />
      ) : (
        <div>
          <br />
          <Button
            style={{ marginLeft: "16px" }}
            loading={isLoading}
            onClick={chartModalStatus(0)}
          >
            {t("button.checkCostPerPrintEvol")}
          </Button>
          <br />
          <br />

          <div className="card-deck mb-2 ">
            {consolidatePrintVolumeReport.length > 0 ? (
              <RenderPrintVolumeReport
                consolidatePrintVolumeReport={consolidatePrintVolumeReport}
                isLoading={isLoading}
                series4={series4.length > 0}
              />
            ) : (
              <RenderEmptyCard />
            )}
            {suppliesBonus.length > 0 ? (
                <RenderSuppliesBonus
                  suppliesBonus={suppliesBonus}
                  isLoading={isLoading}
                  setShowBonusIssueModal={setShowBonusIssueModal}
                  logs={logs}
                  setLogs={setLogs}
                  dateSelected={{
                    month: parseInt(moment(dateSelected).format("M")),
                    year: parseInt(moment(dateSelected).format("YYYY")),
                  }}
                  loadDatesSelect={loadDatesSelectOptimized}
                  reportDates={reportDates}
                  endUser={endUser}
                  fetchdata={fetchData}
                />
            ) : (
              <RenderEmptyCard />
            )}
            {specialCondition != undefined ? (
              (currentUser.idEndUser=='E2300727' || currentUser.idEndUser=="E2300732")?(
                <></>
              ):(<RenderSpecialCondition
                consolidatePrintVolumeReport={consolidatePrintVolumeReport}
                isLoading={isLoading}
                series4={series4.length > 0}
                dateSelected={dateSelected}
              />)
              
            ) : (
              creditNoteAdjustment.length > 0 && currentUser.idRole != 11 && currentUser.idRole != 12 ? (
                <RenderCreditNoteManualAdjustments
                  creditNoteAdjustment={creditNoteAdjustment}
                  isLoading={isLoading}
                />
              ) : <RenderEmptyCard />
            )}
            {suppliesCompensation.length > 0 ? (
              <RenderSuppliesCompensation
                suppliesCompensation={suppliesCompensation}
                isLoading={isLoading}
                setShowCompensationIssueModal={setShowCompensationIssueModal}
                renderStatementButton={renderStatementButton()}
                handleStatementReport={handleStatementReport}
                logs={logs}
                setLogs={setLogs}
                dateSelected={{
                  month: parseInt(moment(dateSelected).format("M")),
                  year: parseInt(moment(dateSelected).format("YYYY")),
                }}
                loadDatesSelect={loadDatesSelectOptimized}
                reportDates={reportDates}
                endUser={endUser}
              />
            ) : (
              undefined
            )}
            {creditNoteAdjustment.length > 0 && currentUser.idRole != 11 && currentUser.idRole != 12 && specialCondition != undefined ? (
              <RenderCreditNoteManualAdjustments
                creditNoteAdjustment={creditNoteAdjustment}
                isLoading={isLoading}
              />
            ) : <RenderEmptyCard />}
          </div>
          <br />
        </div>
      ),
    };
    
    if (presses === undefined || presses.length === 0) return null;

    const tabs = presses.map((press, index) => {
      return {
        id: press.idPress,
        label: press.clickProgram ? (press.idPress + "-" + press.classification+"-Click"):(press.idPress + "-" + press.classification+"-ALC") ,
        content: (
          <div>
            <br />
            <div className="card-deck mb-2 container">
              <div className="card mb-2 box-shadow">
                <div className="card-header text-center">
                  <h5>CPP</h5>
                </div>
                <div>
                  <CPP
                    isLoading={isLoading}
                    press={press}
                    onClickUnderstandCalc={alertModalStatus(index + 1)}
                    costPerPrint={costPerPrint.find(
                      (v) => v.idPress === press.idPress
                    )}
                    consolidatePrintVolumeReport={consolidatePrintVolumeReport}
                  />
                </div>
              </div>
              <div className="card mb-2 box-shadow">
                <div className="card-header text-center">
                  <h5><Trans i18nKey="printing_volume" /></h5>
                </div>
                <div>
                  {/* {this.renderPrintingVolume(press)} */}
                  <PrintingVolume
                    isLoading={isLoading}
                    consolidatePrintVolumeReport={consolidatePrintVolumeReport}
                    press={press}
                  />
                  <p>
                    {t("report.details.infCollectedMsg")}
                    {moment(dateSelected).endOf("month").format("DD-MMM-YYYY")}
                  </p>
                </div>
              </div>
            </div>
            <div className="card-deck mb-2 ">
              <div className="card mb-2 box-shadow">
                <div className="card-header text-center">
                  <h5>
                  <Trans i18nKey="supplies_report_period" />{" "}
                    {moment(dateSelected)
                      .subtract(2, "month")
                      .format("DD/MMM/YYYY")}{" "}
                    -{" "}
                    {moment(dateSelected).endOf("month").format("DD/MMM/YYYY")}
                  </h5>
                </div>
                <div>
                  <SuppliesReport
                    isLoading={isLoading}
                    press={press}
                    suppliesReport={suppliesReport}
                  />
                  <br />
                  <b>
                    {t("report.details.infCollectedMsg")}
                    {moment(dateSelected).endOf("month").format("DD-MMM-YYYY")}
                  </b>
                  <p>{t("report.details.suppliesReport.text1")}</p>
                  <p>{t("report.details.suppliesReport.text2")}</p>
                  <p>{t("report.details.suppliesReport.text3")}</p>

                  <p>{t("report.details.suppliesReport.text*")}</p>
                </div>
              </div>
            </div>
          </div>
        ),
      };
    });

    const list = [mainTab, ...tabs];
    //const list = [mainTab];
    const tab = (
      <Tabs
        controlId="default"
        onChangeTab={selectTab()}
        selectedTabId={activeTabIndex}
        // activeTabIndex={activeTabIndex}
        //theme="underline"
        //mountAllTabContents={false}
        tabs={list}
      >
        {list}
      </Tabs>
    );

    return tab;
  };

  const [sending, setSending] = useState(false);
  const BonusReceivedConfirmationModal = () => {
    const handleRadioButtonChange = (e) => {
      const newState = {
        ...radioButtonsState,
        [e.target.name]: e.target.value,
      };

      const month = e.target.name.substring(11, 14);
      const year = e.target.name.substring(14);
      let monthIdx = pendingBonusReceivedConfirmation.findIndex(x => x === (month + ' ' + year));

      if (e.target.value == 1 && monthsToConfirm.length < pendingBonusReceivedConfirmation.length) monthIdx++;

      let newMonths = [];
      for (let i = 0; i < (monthIdx + 1); i++) {
        newMonths.push(i);
      }

      setMonthsToConfirm(newMonths);

      setRadioButtonsState(newState);
    };

    function getRadioButtons() {
      let radioButtons = new Array();
      let item;
      let stateKey = "";

      for (let i = 0; i < pendingBonusReceivedConfirmation.length; i++) {
        item = pendingBonusReceivedConfirmation[i];
        stateKey = "radioButton" + item.replace(/ /g, "");
        radioButtons.push(
          <div key={stateKey} style={{ display: monthsToConfirm.findIndex(x => x === i) >= 0 ? 'block' : 'none' }}>
            <label style={{ marginBottom: "12px" }}>{item + "?"}</label>
            <RadioButtons
              key={stateKey}
              name={stateKey}
              alignment="horizontal"
              value={radioButtonsState[stateKey]}
              onChange={handleRadioButtonChange}
            >
              <RadioButton value="1" label="Yes" />
              <RadioButton value="0" label="No" />
            </RadioButtons>
          </div>
        );
      }

      return radioButtons;
    }

    //Check if all is anwswered
    function buttonShouldBeDisabled() {

      //if the last month to confirm is null, return true, since button should be disabled
      if (monthsToConfirm.length == 0) return true;
      const item = pendingBonusReceivedConfirmation[monthsToConfirm[monthsToConfirm.length - 1]];
      const key = "radioButton" + item.replace(/ /g, "");

      if (Object.keys(radioButtonsState).length == 0 || radioButtonsState[key] == null) return true;

      return false;
    }

    function handleClick() {
      
    
      setSending(true);

      let answers = new Array();
      let key = "";

      for (let i = 0; i < pendingBonusReceivedConfirmation.length; i++) {
        let item = pendingBonusReceivedConfirmation[i];
        if (monthsToConfirm.findIndex(x => x === i) < 0) break;
        key = "radioButton" + item.replace(/ /g, "");
        answers.push({
          month: months.indexOf(key.substring(11, 14)) + 1,
          year: parseInt(key.substring(14)),
          actionDescription:
            radioButtonsState[key] == "1"
              ? "Bonus Received Confirmation"
              : "Bonus Not Received Yet",
        });
      }

      const handleResponse = () => {
        setSending(false);
        setShowBonusReceivedConfirmationModal(false);
      };

      connectApi
        .get(
          "api/Channels/updateBonusReceivedConfirmation",
          {
            params: {
              answers: JSON.stringify(answers),
              idEndUser: endUser.idEndUser,
              idUser: currentUser.idUser,
            },
          },
          handleResponse
        )
        .catch((error) => {
          setShowBonusReceivedConfirmationModal(false);
          Swal.fire(
            "Error " + error.response.status,
            error.response.data,
            "error"
          );
        });
    }

    const modal = (
      <Modal
        show={showBonusReceivedConfirmationModal}
        title={t("pleaseAnswerTheFollowingQuestion")}
        footer={
          <div className="vn-button-group--responsive">
            <Button
              onClick={handleClick}
              disabled={buttonShouldBeDisabled()}
              loading={sending}
            >
              {t("send")}
            </Button>
          </div>
        }
      >
        <div>
          <label style={{ marginBottom: "16px", fontWeight: "bold" }}>
            {t("bonusReceivedConfirmationQuestion")}
          </label>
          {getRadioButtons()}
        </div>
      </Modal>
    );

    return modal;
  };

  const [bonusIssueDescription, setBonusIssueDescription] = useState("");
  const [sendingBonus, setSendingBonus] = useState(false);
  const BonusIssueModal = () => {

    function handleClick() {
      setSendingBonus(true);

      function handleResponse() {
        setShowBonusIssueModal(false);
        setSendingBonus(false);

        const newLog = {
          month: parseInt(moment(dateSelected).format("M")),
          year: parseInt(moment(dateSelected).format("YYYY")),
          actionDescription: "Bonus Issue Raised",
        };

        let newLogs = [...logs];
        newLogs.unshift(newLog);

        setLogs(newLogs);
      }

      connectApi
        .get(
          "api/Channels/raiseIssue",
          {
            params: {
              month: parseInt(moment(dateSelected).format("M")),
              year: parseInt(moment(dateSelected).format("YYYY")),
              idEndUser: endUser.idEndUser,
              idUser: currentUser.idUser,
              actionDescription: "Bonus Issue Raised",
              issueDescription: bonusIssueDescription,
              endUserName: endUser.endUserName,
              userEmail: currentUser.email,
            },
          },
          handleResponse
        )
        .catch((error) => {
          setShowBonusIssueModal(false);
          setSendingBonus(false);
          Swal.fire(
            "Error " + error.response.status,
            error.response.data,
            "error"
          );
        });
    }

    return (
      <Modal
        show={showBonusIssueModal}
        footer={
          <div className="vn-button-group--responsive">
            <Button
              onClick={handleClick}
              disabled={bonusIssueDescription.length == 0}
              loading={sendingBonus}
            >
              {t("send")}
            </Button>

            <Button
              appearance="secondary"
              onClick={() => {
                setShowBonusIssueModal(false);
              }}
              loading={sendingBonus}
            >
              {t("cancel")}
            </Button>
          </div>
        }
      >
        <div>
          <label style={{ fontWeight: "bold", marginBottom: "12px" }}>
            {t("tellUsMoreAboutTheIssue")} {t("bonus")}:
          </label>
          <TextArea
            id="bonusIssueTextArea"
            value={bonusIssueDescription}
            placeholder={t("describeTheIssue")}
            onChange={setBonusIssueDescription}
            maxLength={500}
          />
        </div>
      </Modal>
    );
  };
 
  const [compIssueDescription, setCompIssueDescription] = useState("");
  const [sendingCIM, setSendingCIM] = useState();
  const CompensationIssueModal = () => {

    function handleClick() {
      
      setSendingCIM(true);

      function handleResponse() {
        setShowCompensationIssueModal(false);
        setSendingCIM(false);

        const newLog = {
          month: parseInt(moment(dateSelected).format("M")),
          year: parseInt(moment(dateSelected).format("YYYY")),
          actionDescription: "Compensation Issue Raised",
        };

        let newLogs = [...logs];
        newLogs.unshift(newLog);

        setLogs(newLogs);
      }

      connectApi
        .get(
          "api/Channels/raiseIssue",
          {
            params: {
              month: parseInt(moment(dateSelected).format("M")),
              year: parseInt(moment(dateSelected).format("YYYY")),
              idEndUser: endUser.idEndUser,
              idUser: currentUser.idUser,
              actionDescription: "Compensation Issue Raised",
              issueDescription: compIssueDescription,
              endUserName: endUser.endUserName,
              userEmail: currentUser.email,
            },
          },
          handleResponse
        )
        .catch((error) => {
          setShowCompensationIssueModal(false);
          setSendingCIM(false);
          Swal.fire(
            "Error " + error.response.status,
            error.response.data,
            "error"
          );
        });
    }

    return (
      <Modal
        show={showCompensationIssueModal}
        footer={
          <div className="vn-button-group--responsive">
            <Button
              onClick={handleClick}
              disabled={compIssueDescription.length == 0}
              loading={sendingCIM}
            >
              {t("send")}
            </Button>

            <Button
              appearance="secondary"
              onClick={() => setShowCompensationIssueModal(false)}
              loading={sendingCIM}
            >
              {t("cancel")}
            </Button>
          </div>
        }
      >
        <div>
          <label style={{ fontWeight: "bold", marginBottom: "12px" }}>
            {t("tellUsMoreAboutTheIssue")} {t("compensation")}:
          </label>
          <TextArea
            id="compIssueTextArea"
            value={compIssueDescription}
            placeholder={t("describeTheIssue")}
            onChange={setCompIssueDescription}
            maxLength={500}
          />
        </div>
      </Modal>
    );
  };
  
  return loadingInitData ? (
    <ProgressIndicator appearance="linear" />
  ) : (
    (reportDates.length==0)?(
      <h1>{t("NoData")}{JSON.parse(localStorage.getItem("last_publish"))}</h1>
    ):(
      <div>
        <div
          style={{
            position: "fixed",
            zIndex: "4",
            width: "100%",
            backgroundColor: "white",
            borderBottomStyle: "solid",
            borderBottomColor: "#ebebeb",
            borderBottomWidth: "thin",
          }}
        >
          <br />
          <h4>
            {t("cost per print")} -{" "}
            {endUser === undefined ? "" : endUser?.endUserName}
          </h4>
          <p>
            {t("channel")}
            {endUser === undefined ? "" : endUser?.customerName}
          </p>
          <br />
          <RenderDateList />
        </div>
        <br />
        <div style={{ marginTop: "132px" }}>
          {
            <RenderTabs />
          }
        </div>
        <br />
        <br />
        <UnderstandCalculation
          consolidatePrintVolumeReport={consolidatePrintVolumeReport}
          activePress={presses.find((p) => p.idPress === activePress)}
          costPerPrint={costPerPrint}
          showAlertModal={showAlertModal}
          configtable={Configtable}
          onClose={closeModal}
        />
        <RenderChart
          dateSelected={dateSelected}
          costPerPrintEvolution={costPerPrintEvolution}
          showChartModal={showChartModal}
          closeChartModal={closeChartModal}
        />
        <BonusReceivedConfirmationModal />
        <BonusIssueModal />
        <CompensationIssueModal />
      </div>
    )

    
  );
};

export default Details;
